import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PerformanceService {
    constructor(@Inject(PLATFORM_ID) private platformId: object) {}

    measurePageLoad(): void {
        if (!isPlatformBrowser(this.platformId) || typeof window === 'undefined') {
            return;
        }

        window.addEventListener(
            'load',
            () => {
                const [navigation] = performance.getEntriesByType(
                    'navigation'
                ) as PerformanceNavigationTiming[];

                if (!navigation || !(window as any).gtag) {
                    return;
                }

                (window as any).gtag('event', 'page_performance', {
                    domInteractive: navigation.domInteractive - navigation.fetchStart,
                    loadComplete: navigation.loadEventEnd - navigation.fetchStart,
                    response: navigation.responseEnd - navigation.responseStart,
                });
            },
            { once: true }
        );
    }
}
